import { Car, Building2, Briefcase, Truck, ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";

const ITEMS = [
  {
    icon: Car,
    title: "For everyday drivers",
    body: "Stop writing your number on dashboard notes. Switch to a permanent, masked contact line.",
    img: "https://images.unsplash.com/photo-1772631327083-10df47b724e6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHwxfHxwZXJzb24lMjBzY2FubmluZyUyMHBob25lJTIwYXQlMjBjYXJ8ZW58MHx8fHwxNzc5MjQzMzczfDA&ixlib=rb-4.1.0&q=85",
  },
  {
    icon: Truck,
    title: "For fleets & couriers",
    body: "Co-branded stickers, scan analytics, in/out logs and a fleet dashboard for ops.",
    img: "https://images.pexels.com/photos/7362883/pexels-photo-7362883.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    icon: Building2,
    title: "For societies & lots",
    body: "Manage visitor vehicles, gate-pass logs, and boom-barrier integrations — one QR each.",
    img: "https://images.pexels.com/photos/28986830/pexels-photo-28986830.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    icon: Briefcase,
    title: "For resellers & garages",
    body: "20-tag starter kits, training, marketing assets, and dedicated managers. Earn while you sell.",
    img: "https://images.pexels.com/photos/7946957/pexels-photo-7946957.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
];

export default function Solutions() {
  return (
    <section id="solutions" data-testid="solutions-section" className="section-pad bg-white">
      <div className="container-secqre">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12">
          <div className="max-w-2xl">
            <span className="overline">— Solutions</span>
            <h2 className="mt-4 font-heading font-bold text-4xl sm:text-5xl tracking-tight" data-testid="solutions-heading">
              Built for everyone who parks.
            </h2>
          </div>
          <Link to="/solutions" className="inline-flex items-center gap-2 text-sm font-semibold text-[#0A0A0A] hover:text-[#0F172A]" data-testid="solutions-explore-link">
            Explore all solutions <ArrowUpRight className="w-4 h-4" />
          </Link>
        </div>

        <div className="grid md:grid-cols-2 gap-5 md:gap-6">
          {ITEMS.map((it, i) => (
            <article key={i} className="group relative overflow-hidden rounded-2xl border border-[#E2E8F0] bg-white transition-all hover:-translate-y-1 hover:border-[#0F172A]/40" data-testid={`solution-card-${i}`}>
              <div className="relative aspect-[16/9] overflow-hidden bg-[#F8F9FA]">
                <img src={it.img} alt={it.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.04]" loading="lazy" />
                <div className="absolute top-4 left-4 inline-flex items-center justify-center w-11 h-11 rounded-lg bg-white border border-[#E2E8F0]">
                  <it.icon className="w-5 h-5 text-[#0F172A]" />
                </div>
              </div>
              <div className="p-7">
                <h3 className="font-heading font-bold text-2xl text-[#0A0A0A]">{it.title}</h3>
                <p className="mt-2 text-[#475569] leading-relaxed">{it.body}</p>
                <Link to="/solutions" className="mt-5 inline-flex items-center gap-1.5 text-sm font-semibold text-[#0A0A0A]" data-testid={`solution-link-${i}`}>
                  Learn more <ArrowUpRight className="w-4 h-4" />
                </Link>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
